/**
 * SQLite-backed implementation of the workspace snapshot store (Phase 1).
 * Same contract as localWorkspaceStore/gitWorkspaceStore: load returns a full
 * normalized snapshot, save takes a partial + options (skipEmptyArrays).
 * The diffing, versioning, and outbox writes all happen on the Rust side in
 * one transaction — this file is deliberately thin.
 */
import { loadDbSnapshot, saveDbSnapshot } from './syncStore';
import { normalizeSnapshot } from './localWorkspaceStore';
import { workspaceDbKey } from './workspaceDbMigration';

export async function loadSqliteSnapshot(workspace) {
  const id = workspaceDbKey(workspace);
  if (!id) return normalizeSnapshot(null);
  const snapshot = await loadDbSnapshot(id);
  // Rust assembles the canonical shape already; normalize defensively so a
  // schema drift never leaks an unexpected shape into the stores.
  return normalizeSnapshot(snapshot);
}

export async function saveSqliteSnapshot(workspace, partial, options = {}) {
  const id = workspaceDbKey(workspace);
  if (!id) return;
  await saveDbSnapshot(id, partial, {
    skipEmptyArrays: options.skipEmptyArrays === true,
  });
}
